import React from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LeaflogixAccount from "../../../components/forms/LeaflogixAccount.js";
import { Container, Grid, Tab, Tabs } from "@mui/material";
import { fetchLeaflogixAccounts } from "../../../redux/models/integrations/Action.js";
import { Syncs } from "../../../components/forms/Syncs.js";
import {isEmpty} from "weed-js";
import {ABORTED } from "../../../redux/constants.js";
import Loading from "../../../components/elements/Loading.js";
import {memberIsAdmin, memberIsSuperAdmin} from "weed-js";
import {
    AUTHENTICATION,
    BACKFILLS,
    ROUTES_INTEGRATIONS_LEAFLOGIX_DETAIL_AUTHENTICATION,
    ROUTES_INTEGRATIONS_LEAFLOGIX_DETAIL_BACKFILLS,
    ROUTES_INTEGRATIONS_LEAFLOGIX_LIST
} from "../../../utils/Constants.js";


const Detail = ({ selectedOrganization, tab, subscriptions, subscriptionItems, subscriptionProducts}) => {
    const params = useParams();
    const dispatch = useDispatch();
    const leaflogixAccountId = parseInt(params.id);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();

    const [leaflogixAccounts, setLeaflogixAccounts] = useState([]);

    const loggedInUser = useSelector(state => state.userReducer.loggedInUser.user || {});
    const organizationUsers = useSelector(state => state.userReducer.loggedInUser.organizationUsers);
    const userProfile = useSelector(state => state.userReducer.loggedInUser.profile);
    const [isLoading, setIsLoading] = useState(true); // useSelector(state => state.userReducer.loading);
    const organizations = useSelector(state => state.userReducer.loggedInUser.organizations);

    const TabPanel = ({ children, index }) => {
        if (index === selectedTab) {
            return <>{children}</>;
        }
        return "";
    };

    useEffect(() => {
        const abortController = new AbortController();
        setIsLoading(true);
        const params = isEmpty(selectedOrganization) ? {} : {organization_id: selectedOrganization.id};
        dispatch(fetchLeaflogixAccounts(params, abortController)).then((fetchedLeaflogixAccounts) => {
            setLeaflogixAccounts(fetchedLeaflogixAccounts);
            setIsLoading(false);
        }).catch(err => {
            setIsLoading(false);
            if (err !== ABORTED) {
                console.error(err);
            }
        });
        return () => {
            abortController.abort();
        };
    }, [loggedInUser.id]);

    const tabs = {
        null: 1,
        undefined: 1,
        [AUTHENTICATION]: 1,
        [BACKFILLS]: 2,
    };


    const whichTab = searchParams.get("tab") || tab;
    const leaflogixAccount = leaflogixAccounts.find(ma => parseInt(ma.id) === leaflogixAccountId);
    const [selectedTab, setSelectedTab] = useState(tabs[whichTab]);
    const selectTab = (event, newValue) => {
        setSelectedTab(newValue);
        if (newValue === tabs[AUTHENTICATION]) {
            navigate(ROUTES_INTEGRATIONS_LEAFLOGIX_DETAIL_AUTHENTICATION.replace(":id", leaflogixAccountId));
        } else if (newValue === tabs[BACKFILLS]) {
            navigate(ROUTES_INTEGRATIONS_LEAFLOGIX_DETAIL_BACKFILLS.replace(":id", leaflogixAccountId));
        }
    };

    if (isLoading) { // isEmpty(leaflogixAccount)) {
        return <Container className={"leaflogix-account-detail workspace"}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Loading fullscreen={true}/>
                </Grid>
            </Grid>
        </Container>;
    }

    if (isEmpty(leaflogixAccount)) {
        return <Container className={"leaflogix-account-detail workspace"}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <h1>Dutchie Account Details</h1>
                    <h2>View/Edit</h2>
                </Grid>
                <Grid item xs={12}>
                    <h2>(Not found)</h2>
                </Grid>
            </Grid>
        </Container >;
    }

    const isAdmin = memberIsAdmin(loggedInUser, organizationUsers, selectedOrganization);
    const isSuper = memberIsSuperAdmin(loggedInUser, organizationUsers, selectedOrganization);
    const enableForm = isAdmin || isSuper;

    return <Container className="leaflogix-account-detail workspace">
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <h1>Dutchie Account Details</h1>
                <h2>View/Edit</h2>
            </Grid>
        </Grid>
        <Tabs value={selectedTab} onChange={selectTab}>
            <Tab label="Authentication" value={1} tabIndex={1} />
            <Tab label="Data Sync Status" value={2} tabIndex={2} />
        </Tabs>
        <TabPanel index={1}>
            <LeaflogixAccount
                create={false}
                enableDelete={enableForm}
                enableEdit={enableForm}
                onDelete={(id) => {
                    setLeaflogixAccounts((state) => {
                        return state.filter(ma => {return parseInt(ma.id) !== id;});
                    });
                    navigate(ROUTES_INTEGRATIONS_LEAFLOGIX_LIST);
                }}
                {...leaflogixAccount}
            />
        </TabPanel>
        <TabPanel index={2} onClick={() => navigate(ROUTES_INTEGRATIONS_LEAFLOGIX_DETAIL_BACKFILLS.replace(":id", leaflogixAccountId))} >
            <Syncs
                selectedOrganization={selectedOrganization}
                integrationAccountId={leaflogixAccountId}
                loggedInUser={loggedInUser}
                integrationNamespace={"dutchie"}
            />
        </TabPanel>
    </Container >;
};


export default Detail;